var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper contact-sales"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('ContactSalesForm',{staticClass:"mt-10 mb-10"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }